import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { EmergencyBar } from "./EmergencyBar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CustomCursor } from "./CustomCursor";
import { RevealManager, SmoothScroll, ScrollToTop } from "../../lib/motion";

export const Layout = () => (
  <div className="grain flex min-h-screen flex-col bg-navy">
    <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-14 focus:z-[80] focus:rounded-full focus:bg-gold focus:px-4 focus:py-2 focus:text-navy">
      Skip to content
    </a>
    <div className="sticky top-0 z-50">
      <EmergencyBar />
      <Header />
    </div>
    <main id="main" className="flex-1">
      <Suspense fallback={<div className="min-h-[100svh]" aria-busy="true" />}>
        <Outlet />
      </Suspense>
    </main>
    <Footer />
    <RevealManager />
    <SmoothScroll />
    <ScrollToTop />
    <CustomCursor />
  </div>
);
